import { IoMdClose } from 'react-icons/io';

const Modal = ({ title, desc, isOpen, onClose, children }) => {
  return (
    <>
      {isOpen && (
        <>
          {/* eslint-disable-next-line */}
          <div
            className="fixed inset-0 z-[110] bg-black bg-opacity-50"
            onClick={onClose}
          ></div>
          <div className="br-1 text-p-text fixed left-[50%] top-[50%] z-[120] flex max-h-[min(800px,calc(100vh-2rem))] max-w-[calc(100vw-2rem)] translate-x-[-50%] translate-y-[-50%] flex-col rounded-lg border bg-zinc-900 shadow-2xl max-sm:w-[80%] sm:min-w-[200px]  md:min-w-[600px]">
            <div className="flex min-h-0 flex-1 flex-col">
              <header className="br-1 flex items-center justify-between border-b border-zinc-700 px-8 py-4">
                <div className="flex flex-col gap-1">
                  <span className="p-text text-lg font-semibold">{title}</span>
                  <span className="s-text text-sm">{desc}</span>
                </div>
                <button
                  onClick={onClose}
                  type="button"
                  className="text-md rounded-[3px] text-xl font-semibold text-zinc-400 transition-colors duration-150 ease-in-out hover:text-zinc-100 disabled:cursor-not-allowed"
                >
                  <IoMdClose />
                </button>
              </header>
              <div className="flex-1 overflow-y-auto">{children}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Modal;
